// extracted by mini-css-extract-plugin
export var container = "styles-module--container--KWfdy";
export var top = "styles-module--top--mhPgL";
export var bottom = "styles-module--bottom--za2n5";
export var shrink = "styles-module--shrink--UmsW5";
export var expand = "styles-module--expand--D1Cua";
export var backAndForthRight = "styles-module--backAndForthRight--EXqoZ";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--YkLXp";
export var animateBg = "styles-module--animateBg--QTR2G";